<template>
  <v-card
    class="delivery-status-density mx-auto pa-2"
    outlined
  >
<!--    <span>{{periodReport}}</span>-->
    <v-list-item >
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Báo cáo giao hàng theo khoảng thời gian
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <div v-if="!_.isEmpty(periodReport.labels)">
      <chartist
        v-if="!loadingReportPeriod"
        ratio="ct-major-second"
        type="Pie"
        :data="periodReport"
        :options="chartOptions"
      >
      </chartist>

      <ul class="description">
        <li v-for="(item, index) in periodReport.deliveryName" :key="index">
          <v-avatar
            tile
            v-bind:style="{'background-color':periodReport.color[item.key]}"
            size="20"
          />
          {{item.value}}
        </li>
      </ul>
    </div>
    <common-no-result
      v-else
    />
    
  </v-card>
</template>

<script>
import * as ChartistTooltips from 'chartist-plugin-tooltips';

  export default {
    props: {
      periodReport: {
        default: () => ({})
      },
      loadingReportPeriod: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        chartOptions: {
          height: 300,
          plugins: [this.$chartist.plugins.tooltip({
            transformTooltipTextFnc: (e) => {
             return e + '%'
            }
          })]
        },
      }
    },
    created() {
    },
    methods: {
    },
  }
</script>

<style lang="scss">
  .ct-major-second {
    svg {
      position: relative;
    }
    &:before {
      padding-bottom: 0;
    }
  }

  .delivery-status-density {
    .ct-series-a .ct-slice-pie {
      fill: yellow;
    }

    .ct-series-b .ct-slice-pie {
      fill: red;
    }

    .ct-series-c .ct-slice-pie {
      fill: green;
    }

    .ct-series-d .ct-slice-pie {
      fill: royalblue;
    }

    .ct-series-e .ct-slice-pie {
      fill: darkgray;
    }

    .ct-series-f .ct-slice-pie {
      fill: hotpink;
    }

    .ct-series-g .ct-slice-pie {
      fill: aqua;
    }

    .ct-series-h .ct-slice-pie {
      fill: gold;
    }

    .ct-series-i .ct-slice-pie {
      fill: blueviolet;
    }

    .ct-series-j .ct-slice-pie {
      fill: maroon;
    }

    .ct-label {
      fill: white;
    }
  }
</style>